import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import {
  GetAgendaAvailableItemsDocument,
  GetAgendaAvailableItemsQueryVariables,
} from '../../types/api/graphql';

export function useAgendaAvailableItems(
  variables: GetAgendaAvailableItemsQueryVariables,
  skip?: boolean
) {
  const {
    data: agendaAvailableItemsData,
    loading: agendaAvailableItemsLoading,
  } = useQuery(GetAgendaAvailableItemsDocument, {
    variables: {
      ...variables,
    },
    skip:
      skip === true ||
      !variables.healthProviderId ||
      !variables.startDate ||
      !variables.endDate ||
      !variables.consultType,
    fetchPolicy: 'network-only',
  });

  const data = useMemo(
    () => agendaAvailableItemsData?.agenda ?? [],
    [agendaAvailableItemsData?.agenda]
  );

  return {
    data,
    loading: agendaAvailableItemsLoading,
  };
}
